export function calculateDays(entryDate, exitDate) {
  const entry = new Date(entryDate.split(" ")[0]);
  const exit = new Date(exitDate);
  const differenceInTime = exit.getTime() - entry.getTime();

  if (entry.toDateString() === exit.toDateString()) {
    return 1;
  }

  const differenceInDays =
    Math.floor(differenceInTime / (1000 * 60 * 60 * 24)) + 1;

  return differenceInDays;
}
